import { nullable, struct } from 'io-ts/Decoder';

import { Id as UserId } from '../../../../user/Id';

export const Params = struct({
	userId: nullable(UserId),
});
